<template>
  <div id="pers-tab4" name="hres31x-tab4" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-if="detail.tableIncome.total > 0">
      <!--Start Topic #1-->
      <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
        <i class="fa fa-btc icon-sub-topic" aria-hidden="true"></i>
        <div class="sub-topic">{{ labels['HRES31XC1']['310'] }}</div>
      </div>

      <div class="data-pers-box" v-show="subTopic1">
        <div class="row income-table-box">
          <div class="col-xs-6 col-sm-6 blank-col"></div>
          <div class="col-xs-1 col-sm-2 blank-col"></div>
          <div class="col-xs-5 col-sm-4 currency">{{ labels['HRES31XC4']['20'] }} : {{ detail.detail.desc_codecurr }}</div>
        </div>

        <div class="row income-table-box">
          <div class="col-xs-12 col-sm-5 income-table-heading bg-color-skin">{{ labels['HRES31XC4']['30'] }}</div>
          <div class="col-xs-6 col-sm-3 income-table-heading-center bg-color-skin">{{ labels['HRES31XC4']['40'] }}</div>
          <div class="col-xs-6 col-sm-4 income-table-heading-right bg-color-skin">{{ labels['HRES31XC4']['50'] }}</div>
        </div>

        <template v-for="(value, index) in detail.tableIncome.rows">
          <div class="row income-table-box" :class="{'even' : !pcDisp && index%2 == 0}">
            <div class="col-xs-12 col-sm-5 income-table-body-left">{{ value.code }} - {{ value.desc_income }}</div>
            <div class="col-xs-6 col-sm-3 income-table-body-center">{{ value.unit }}</div>
            <div class="col-xs-6 col-sm-4 income-table-body-right">{{ value.qtyincome }}</div>
          </div>
        </template>


        <div class="row income-table-box">
          <div class="col-xs-12 blank">&nbsp;</div>
          <div class="col-xs-12 bg-color-skin income-table-sum-header" v-show="!pcDisp">{{ constLabels[nowLang].summary }}</div>
        </div>

        <div class="row income-table-box">
          <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
          <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['60'] }}</div>
          <div class="col-xs-6 col-sm-4 income-table-sum-right" :class="{'bg-color-skin' : pcDisp}">{{ detail.detail.hour_income }}</div>
        </div>
        <div class="row income-table-box">
          <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
          <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['70'] }}</div>
          <div class="col-xs-6 col-sm-4 income-table-sum-right" :class="{'bg-color-skin' : pcDisp}">{{ detail.detail.day_income }}</div>
        </div>
        <div class="row income-table-box">
          <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
          <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['80'] }}</div>
          <div class="col-xs-6 col-sm-4 income-table-sum-right" :class="{'bg-color-skin' : pcDisp}">{{ detail.detail.month_income }}</div>
        </div>

  <!--        <template v-for="(value, index) in detail.tableSummary.rows">
          <div class="row income-table-box">
            <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
            <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['60'] }}</div>
            <div class="col-xs-6 col-sm-4 income-table-sum-right" :class="{'bg-color-skin' : pcDisp}">{{ value.hour_income }}</div>
          </div>
          <div class="row income-table-box">
            <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
            <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['70'] }}</div>
            <div class="col-xs-6 col-sm-4 income-table-sum-right" :class="{'bg-color-skin' : pcDisp}">{{ value.day_income }}</div>
          </div>
          <div class="row income-table-box">
            <div class="col-sm-5 income-table-sum-left" v-show="pcDisp"></div>
            <div class="col-xs-6 col-sm-3 income-table-sum-center" :class="{'bg-color-skin' : pcDisp}">{{ labels['HRES31XC4']['80'] }}</div>
          </div>
        </template> -->
      </div>
      <!--End Topic #1-->
    </template>
  </div>
</template>

<script>
export default {
  name: 'hres31x-tab4',
  data () {
    return {
      constLabels: {
        en: {
          summary: 'Summary of Income'
        },
        th: {
          summary: 'สรุปรายได้'
        }
      },
      subTopic1: true
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>



// WEBPACK FOOTER //
// tab4.vue?2f55c38d